import MotorParseable from "./class.MotorParseable";

export default class DragDropCategories extends MotorParseable {
	isClearButtonEnabled() {
		return this.clearButtonIsEnabled;
	}

	constructor(options) {
		super(options);
		this.clearButtonIsEnabled = false;
	}

	getNewDriver() {
		return new Motors.Drivers.DragDropCategoriesDriver();
	}

	getStartSignal() {
		let draggablesInEachDropArea =
			this.driverOutputs.draggablesInEachDropArea ||
			this.tryJSONParse(this.model.draggablesInEachDropArea) ||
			[];
		let shallowCopyOfDIEDA = draggablesInEachDropArea.map((areaArray) =>
			areaArray.slice()
		);

		return {
			categoryNames: this.tryJSONParse(this.model.categoryNames),
			draggableContents: this.tryJSONParse(this.model.draggableContents),
			areDraggablesReusable: this.model.areDraggablesReusable,
			draggablesInEachDropArea: shallowCopyOfDIEDA, // shallow copy array two levels deep
			numDraggablesInEachRow: this.tryJSONParse(
				this.model.numDraggablesInEachRow
			),
			height: this.model.height,
		};
	}

	getCachedResponseSignal(data) {
		return {
			draggablesInEachDropArea: data.draggablesInEachDropArea,
		};
	}

	onRenderResponse($responseDiv) {
		let response, preview;
		if (
			this.answerKey === "dropAreaColonDraggableList" ||
			this.answerKey === "draggablesInEachDropArea"
		) {
			response = this.driverOutputs[this.answerKey] || "[]";
		}
		if (
			this.previewKey === "dropAreaColonDraggableList" ||
			this.previewKey === "draggablesInEachDropArea"
		) {
			preview = this.driverOutputs[this.previewKey] || [];
			preview = preview.map(function (cat) {
				return cat.length
					? cat.reduce((r, a) => r + a + ",", "[").slice(0, -1) + "]"
					: "[]";
			});
		}

		return new Promise((resolve) => {
			this.clearButtonIsEnabled = !this.isResponseInitial();
			this.rerenderClearButton();

			const isResponseEmpty = this.isResponseEmpty(response);
			if (this.previewKey !== "noPreview") {
				if (isResponseEmpty) {
					$responseDiv.html("<em>No draggables dropped.</em>");
				} else {
					$responseDiv.text(preview);
				}
			}

			this.setSubmittable(response !== undefined && !isResponseEmpty);
			resolve();
		});
	}

	// Not all draggables may fit in a category, and multiple of each
	// may be placed, so all we care about is that at least one draggable
	// should be placed in a category.
	isResponseEmpty(response) {
		if (this.answerKey === "draggablesInEachDropArea") {
			if (response) {
				for (let i = 0; i < response.length; i++) {
					if (response[i].length > 0) {
						return false;
					}
				}
			}
			return true;
		} else if (this.answerKey === "dropAreaColonDraggableList") {
			return !response || response.length === 0;
		}
	}

	isResponseInitial() {
		if (this.driverOutputs["draggablesInEachDropArea"]) {
			const respDIEDA = this.driverOutputs["draggablesInEachDropArea"];
			const modelDIEDA = this.tryJSONParse(this.model.draggablesInEachDropArea);
			if (modelDIEDA) {
				return respDIEDA.every((respCat, i) => {
					if (modelDIEDA[i]) {
						return (
							modelDIEDA[i].length === respCat.length &&
							respCat.every((v, j) => modelDIEDA[i][j] === v)
						);
					} else {
						return respCat.length === 0;
					}
				});
			} else {
				return this.isResponseEmpty(this.driverOutputs[this.answerKey]);
			}
		} else {
			return true;
		}
	}
}
